import template from './menu.html';
import controller from './menu.controller';
import './menu.scss';

let menuComponent = {
  bindings: {
    profiles: '<',
    closingHour: '<'
  },
  template,
  controller
};

export default menuComponent;



// WEBPACK FOOTER //
// ./src/app/components/menu/menu.component.js